import {Modal} from "react-bootstrap";
import React from "react";
import {Settings} from "../http/protocol";
import {isIOS} from "react-device-detect";
import {getContainer} from "../ioc/IOCSetup";
import {ContentModelName, PopupAppInstall} from "../contenful/types";
import {AppState} from "../RootReducer";
import {Dispatch} from "redux";
import {fetchContent} from "../contenful/ContentfulActions";
import {connect} from "react-redux";
import Markdown, {ReactNode} from "react-markdown";
import {t} from "../i18n";
import {getStatusForContent} from "../selectors/content-selectors";
import {ContentStatus} from "../contenful/ContentfulReducer";


interface State {

}

interface Props {
    settings:Settings;
    isIOS?:boolean;
    popupAppInstall?: PopupAppInstall;
    error?: string;
    fetchContent: typeof fetchContent;
    lng?: string;
    close? : () => void;
    popupContentStatus? : ContentStatus;
}

class AppInstallPopUp extends React.Component<Props, State>{
    constructor(props:Props) {
        super(props);
        this.state = {};
    }

    componentDidMount(): void {


        if(isIOS) {
            window.installedUsingNativePrompt = 'popup';
        }
        //set event for appinstalled.
        window.addEventListener('appinstalled', (evt) => {
            localStorage.setItem('appinstalled', 'true');
        });

        if(this.props.popupAppInstall == undefined) {
            if(this.props.error === undefined || this.props.error == 'no content') {
                this.props.fetchContent(ContentModelName.POPUPAPPINSTALL, this.props.lng);
            }
        }
    }

    private show() {

    }

    componentWillUnmount() {
        if(isIOS) {
            window.installedUsingNativePrompt = "native";
        }
    }

    onInstall = () => {
        if ((!window.matchMedia('(display-mode: fullscreen)').matches || !window.matchMedia('(display-mode: standalone)').matches)) {
            window.installedUsingNativePrompt = 'popup';
            this.setState({show:false});
            window.deferredPrompt && window.deferredPrompt.prompt();
        }
    };

    render(): ReactNode | ReactNode[]  {

        if(this.props.popupContentStatus != ContentStatus.SUCCESS) {
            return <></>;
        }

        const popupImage = this.props.popupAppInstall && this.props.popupAppInstall.image ? this.props.popupAppInstall.image.fields.file.url : "";
        const popupTitle = this.props.popupAppInstall && this.props.popupAppInstall.title ? this.props.popupAppInstall.title : "";
        const popupDescription = this.props.popupAppInstall && this.props.popupAppInstall.description ? this.props.popupAppInstall.description : "";
        const popupButtonText = this.props.popupAppInstall && this.props.popupAppInstall.buttonText ? this.props.popupAppInstall.buttonText : "";

        return (
            <Modal show={true}
                   onHide={() => {
                        this.props?.close?.();
                   }}
                   aria-labelledby="contained-modal-title-vcenter"
                   centered
                   className="promoteModalDialog"
                   size="lg">
                <Modal.Header closeButton className="promoteModalHead">
                    <Modal.Title id="contained-modal-title-vcenter" className="promoteModalTitle">
                        {popupTitle}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="promoteModalBody">
                    <>
                        <Markdown className="promoteModalText" children={popupDescription} />
                        <div className="imageWrap">
                            <img className="img-fluid" src={`${popupImage}`}/>
                        </div>
                        {!isIOS && (
                            <div style={{textAlign:"center", marginTop:"1.5rem"}}>
                                <button className="btn btn-cta full-width small" style={{width:"50%"}} onClick={() => this.onInstall()}>{popupButtonText}</button>
                            </div>
                        )}
                        {isIOS && (
                            <div style={{ marginTop:"1rem"}}>
                                {this.renderIosInstructions()}
                            </div>
                        )}
                    </>
                </Modal.Body>
            </Modal>
        )
    }

    renderIosInstructions() {
        let txt = t("app.install.ios", {icon:"ICON"});
        let elements = txt.split("ICON");
        if(elements.length == 2) {
            return <p className="promoteModalText">{elements[0]} <img alt={"promo"} style={{width:"30px", verticalAlign:"bottom"}} src={require('../assets/icon_share.png').default}/> {elements[1]} <span className="material-icons">add</span> </p>;
        } else {
            return <p className="promoteModalText">Just tap <img alt={"promo"} style={{width:"30px", verticalAlign:"bottom"}} src={require('../assets/icon_share.png').default}/> Then "Add to Home Screen"  <span className="material-icons">add</span></p>;
        }
    }
}

const mapStateToProps = (app : AppState) => {
    return {
        error: app.contentful.error,
        popupAppInstall: app.contentful.popupAppInstall,
        lng: getContainer().getSettingsService().getActiveLocale().code,
        settings : app.settings?.settings ?? {},
        popupContentStatus : getStatusForContent(app, ContentModelName.POPUPAPPINSTALL)
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        fetchContent: (contentModelName: ContentModelName, locale?: string) => dispatch(fetchContent(contentModelName, locale) as any)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AppInstallPopUp as any) as any